import ReactComponent from '../app/ReactComponent'
import {Form, Input, Button, Col, Divider, Row, Space, Layout, Spin, Alert} from 'antd'
import {LockOutlined} from '@ant-design/icons'
import {Link} from 'react-router-dom'
import {createRef} from 'react'
import {GoogleLoginButton} from '../components/buttons/GoogleLoginButton'
import {GoogleAuthService} from '../services/GoogleAuthService'
import App from '../app/App'


export class LoginPage extends ReactComponent {
  inputEmail = createRef()
  inputPassword = createRef()
  loginForm = createRef()

  state = {
    loading_page: false,
    loading_form: false,
    linkingMode: false,
    linkingMessage: null
  }
  constructor(props) {
    super(props);
  }

  componentDidMount = async () => {

    this.scrollToTop()

    this.pushPageAnalytics("Přihlášení do Moje Amber")
  }

  async handleLogin(data){

    void this.updateState({loading_form: true})

    const success = await this.props.$auth.authenticate(data)

    void this.updateState({
      loading_form: false,
      ...(success && { linkingMode: false, linkingMessage: null })
    })

  }

  handleGoogleLoginSuccess = async (credentialResponse) => {

    void this.updateState({loading_page: true})

    const result = await GoogleAuthService.handleGoogleLogin(this.props.$auth, credentialResponse)

    void this.updateState({loading_page: false})

    if (result.success) {

      sessionStorage.removeItem('googleUser')

      if (result.needs_completion)
        App.$toast('Registrace přes Google byla úspěšná! Prosím doplňte povinné údaje v profilu.')
      else
        App.$toast('Přihlášení přes Google bylo úspěšné!')

    } else {

      if (result.linking) {

        this.loginForm.setFieldsValue({
          mail: result.userInfo.email,
        })

        void this.updateState({
          linkingMode: true,
          linkingMessage: 'Pro dokončení propojení vašeho účtu s Google přihlášením zadejte prosím vaše stávající heslo k portálu dárce.'
        })

        this.inputPassword.current.focus()

      } else {

        this.handleError(result.error || 'Nastala chyba při Google přihlášení.')

      }

    }
  }

  handleGoogleLoginError = () => {
    this.handleError('Google přihlášení selhalo');
  }

  /**
   *  TODO: This method should be removed in the future
   */
  handleLoginTestCustomer() {
    this.props.$auth.authenticateTestUser()
  }

  render() {
    return (
      <>
        <Layout tagName={"main"} className={"login-page"}>
          {/*<Row justify={"center"}>
            <Image src={Mojeamberkey} alt={''} preview={false} width={"368px"}></Image>
          </Row>*/}
          <Spin spinning={this.state.loading_page} size="large">
            <Row justify={"center"}>
              <Col xs={24} md={20} lg={20} xl={20} style={{maxWidth: '540px'}}>
                <Form name="login"
                      method="post"
                      layout="vertical"
                      onFinish={(...args) => this.handleLogin(...args)}
                      ref={form => this.loginForm = form}
                      labelCol={{
                        span: 16,
                      }}
                      wrapperCol={{
                        span: 24,
                      }}
                      style={{
                        marginTop: "3em",
                        maxWidth: 540,
                      }}
                      initialValues={{
                        remember: true,
                      }}
                >

                  {this.state.linkingMessage && (
                    <Alert
                      message={this.state.linkingMessage}
                      type="info"
                      showIcon
                      style={{ marginBottom: '24px', background: '#ffffff' }}
                    />
                  )}

                  <Form.Item
                    label="Email"
                    name="mail"
                    className={this.state.linkingMode ? 'disabled' : ''}
                    rules={[{
                      required: true,
                      message: "Prosím vyplňte email."
                    }]}
                  >
                    <Input
                      type="email"
                      size="large"
                      placeholder="Zadejte Váš email"
                      autoComplete="on"
                      ref={this.inputEmail}
                      disabled={this.state.linkingMode}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Heslo"
                    name="password"
                    className="password"
                    rules={[{
                        required: true,
                        message: "Prosím vyplňte heslo.",
                    }]}
                  >
                    <Input.Password
                      type="password"
                      size="large"
                      placeholder="••••••••"
                      autoComplete="off"
                      ref={this.inputPassword}/>
                  </Form.Item>


                  <Button type="link" className="recovery-password">
                    <Link to="/lost-password">
                      <LockOutlined/>
                      <span>Zapomenuté heslo</span>
                    </Link>
                  </Button>


                  <Space style={{marginTop: '30px'}} direction="vertical">

                    {/*<Button onClick={() => this.handleLoginTestCustomer()} type="default" size="large">Přihlásit
                      testovacího uživatele</Button>*/}

                    <Button htmlType="submit" type="primary" className="btn btn-primary" icon={<Spin spinning={this.state.loading_form}/>}>Přihlásit se</Button>
                  </Space>
                </Form>
              </Col>
            </Row>
            <Row justify={"center"}>
              <Col xs={24} md={20} lg={20} xl={20} className="dividing-line">
                <Divider orientation="center" plain>
                nebo
                </Divider>
              </Col>
            </Row>
            <Row justify={"center"} style={{marginBottom: '30px'}}>
              <Col xs={24} md={20} lg={20} xl={20} style={{maxWidth: '540px', display: 'flex', justifyContent: 'center'}}>
                <GoogleLoginButton
                  onSuccess={this.handleGoogleLoginSuccess}
                  onError={this.handleGoogleLoginError}
                />
              </Col>
            </Row>
            <Row gutter={[0, 30]} align="center" className="new-account">
              <Col xs={24}>
                <Link to="/registration">
                  <Button className="btn btn-secondary">
                    Vytvořit nový účet Moje Amber
                  </Button>
                </Link>
              </Col>
              <Col xs={16} md={10} lg={8} xl={6} xxl={4} className="new-account-text">
                Jste náš stávající dárce a nemůžete se přihlásit?
                <br/><Link to="/lost-password" style={{color: "inherit", textDecoration: "underline"}}>Klikněte zde</Link> a nastavte si heslo.
              </Col>
            </Row>
          {/*<Row>
            <Col xs={0} md={9} lg={11} xl={13} xxl={15} className="hand-drop-image">
              <Image preview={false} src={require("../image/hand-drop-big@2x.png")}></Image>
            </Col>
          </Row>*/}
          </Spin>
        </Layout>
      </>
    )
  }
}